export const errorDefinitions = [
  {
    ident: "generic",
    title: "Etwas ist schiefgelaufen",
    desc: "Ein unerwartetes Problem ist aufgetreten. Bitte versuche es später erneut.",
    button: "OK",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_email_lock",
    title: "E-Mail-Domain nicht unterstützt",
    desc: "Die eingegebene E-Mail-Domain wird derzeit nicht unterstützt. Probiere es mit einer anderen Domain oder versuche es später erneut.",
    button: "OK",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_insufficient_permissions",
    title: "Zugriff verweigert",
    desc: "Du hast keine Berechtigung, diese Seite aufzurufen.",
    button: "Zurück",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_unauthorized",
    title: "UPSS",
    desc: "Session expired, back to login.",
    button: "OK",
    returnUrl: null,
    disableClose: true,
    updateUserData: false,
    logout: true
  },
  {
    ident: "error_session_not_found",
    title: "UPSS",
    desc: "Session not found, back to offers.",
    button: "OK",
    returnUrl: null,
    disableClose: true,
    updateUserData: false,
    clearSession: true
  },
  {
    ident: "error_yoti_verification_in_progress",
    title: "Verifizierung läuft",
    desc: "Bitte warte einen Moment, während wir deine Identität überprüfen.",
    button: "OK",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_device_already_registered",
    title: "Die Gerätenummer ist falsch oder bereits registriert",
    desc: "Die von dir eingegebene Gerätenummer ist falsch oder wurde bereits dazu benutzt, ein Angebot anzufordern.",
    button: "OK",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_wrong_otp",
    title: "Falscher SMS-Code",
    desc: "Der von dir eingegebene Verifizierungscode ist falsch. Bitte prüfe ihn und versuche es erneut.",
    button: "Versuche es erneut",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_wrong_otp_email",
    title: "Falscher E-Mail-Code",
    desc: "Der von dir eingegebene Verifizierungscode ist falsch. Bitte prüfe ihn und versuche es erneut.",
    button: "Versuche es erneut",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_empty_coupon_database",
    title: "Dieses Angebot ist derzeit nicht auf Lager",
    desc: "Keine Sorge - du kannst es später erneut versuchen. Wir arbeiten daran, den Bestand so bald wie möglich wieder aufzustocken.",
    button: "OK",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_catalogue_expired",
    title: "Angebot abgelaufen",
    desc: "Dieses Angebot ist nicht mehr verfügbar.",
    button: "OK",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_catalogue_locked",
    title: "Verzeihung, dieses Angebot kann nicht gewährt werden",
    desc: "Leider haben wir gerade festgestellt, dass du für dieses Angebot nicht berechtigt bist. Wir entschuldigen uns für die Unannehmlichkeit",
    button: "OK",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_catalogue_limit_exceeded",
    title: "Angebot bereits beansprucht",
    desc: "Du hast dieses Angebot bereits eingelöst.",
    button: "OK",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_mobile_phone_taken",
    title: "Verwendete Telefonnummer",
    desc: "Die Telefonnummer ist bereits mit einem anderen Konto verbunden.",
    button: "Nummer ändern",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_bypass_failed",
    title: "Ungültiger Bypass-Code",
    desc: "Der Code ist falsch. Bitte den Promoter um ein neues.",
    button: "Versuche es erneut",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_bypass_not_found",
    title: "Ungültiger Bypass-Code",
    desc: "Der Code ist falsch. Bitte den Promoter um ein neues.",
    button: "Versuche es erneut",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_expired_otp",
    title: "SMS-Code ist abgelaufen",
    desc: "Der Verifizierungscode ist abgelaufen. Bitte gehe zurück und fordere einen neuen an.",
    button: "OK",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_input_invalid",
    errorField: {
      "store\/ident": {
        title: "Etwas stimmt nicht",
        desc: "Einige deiner Angaben scheinen falsch zu sein. Bitte gehe zurück und überprüfe sie.",
        button: "Zurück",
        returnUrl: "/code"
      }
    },
    title: "Etwas stimmt nicht",
    desc: "Einige deiner Angaben scheinen falsch zu sein. Bitte gehe zurück und überprüfe sie.",
    button: "Zurück",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_schufa_input_invalid",
    title: "Etwas stimmt nicht",
    desc: "Einige deiner Angaben scheinen falsch zu sein. Bitte gehe zurück und überprüfe sie.",
    button: "Zurück",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_schufa_verification_failed",
    title: "Deine Daten wurden nicht erfolgreich verifiziert.",
    desc: "Bitte überprüfe die angegebenen Daten und versuche es erneut.",
    button: "Zurück",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },

  {
    ident: "error_campaign_not_found",
    title: "Angebot nicht gefunden",
    desc: "Dieses Werbeangebot ist nicht mehr vorhanden oder ist eventuell abgelaufen.",
    button: "OK",
    returnUrl: "/",
    disableClose: true,
    updateUserData: false
  },
  {
    ident: "error_campaign_locked",
    title: "Promoter Code / POS code error",
    desc: "Ein falscher Promoter-  bzw. Händler-Code wurde eingegeben. Schließe das Browserfenster und starte nochmal von Anfang an.",
    button: "Zurück",
    returnUrl: null,
    disableClose: true,
    updateUserData: false
  },
  {
    ident: "error_otp_cooldown",
    title: "E-Mail wurde bereits gesendet",
    desc: "An deine E-Mail-Adresse wurde bereits ein Bestätigungscode gesendet. Bitte überprüfe dein Postfach (auch den SPAM-Ordner) und versuche es später erneut.",
    button: "OK",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_email_validation_failed",
    title: "E-Mail konnte nicht gesendet werden",
    desc: "Die E-Mail konnte an die angegebene E-Mail-Adresse nicht zugestellt werden. Bitte überprüfe die Adresse und versuche es noch einmal.",
    button: "E-Mail-Adresse korrigieren",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  },
  {
    ident: "error_email_address_blacklisted",
    title: "E-Mail-Adresse nicht erkannt",
    desc: "Die eingegebene E-Mail-Adresse ist nicht erlaubt. Nutze bitte eine echte E-Mail-Addresse und versuche es erneut.",
    button: "Versuche es erneut",
    returnUrl: null,
    disableClose: false,
    updateUserData: false
  }
];
